import * as Tgcc from '../tgccGlobal'
import * as React from 'react'
import Radium, { StyleRoot } from 'radium'
import {CSSProperties} from 'react'
import {connect} from 'react-redux'



class CatProps extends Tgcc.BaseProps {
    text: string;
    selected: boolean;
    onChange?: (filter: string) => void;
}

const wrapperStyle: CSSProperties = {
    display: 'flex',
    width: '250px',
    margin: '2px 8px',
    overflow: 'hidden',
    cursor: 'pointer',
    height: '24px',
    lineHeight: '22px',
    backgroundColor:'white',
    borderRadius:'20px',
    textAlign:'center',
    '@media (max-width:375px)': {
        width:'190px'
    }
};

const catStyle: CSSProperties = {
    fontFamily:'BarlowMedium',
    fontSize: '13px',
    letterSpacing: '1px',
    fontWeight: "bold",
    whiteSpace: 'nowrap',
    padding: '1px 5px',
    textTransform: 'none',
    backgroundColor: 'transparent',
    textAlign:'center',
    width:'100%'

};

let catStyleSelect = Object.assign({}, catStyle, {backgroundColor: '#323232',color:'white'});

export class _CampusDesignCategory extends React.Component<CatProps, any> {
    
    state = {
        selected: false 
    }

    changeFilter = (category: string) => {
        if(this.props.onChange)
            this.props.onChange(category)
    } 

    render() {
        var cStyle = this.props.selected ? catStyleSelect : catStyle;
        
        return (
            <div style={wrapperStyle}>
                <div style={cStyle} onClick={this.doFilter}>{this.props.text}</div>
            </div>
        )
    }


    doFilter = () => {
        // clear the existing filter if it matches
        if(this.props.selected)
            this.changeFilter(null);
        else 
            this.changeFilter(this.props.text)
    }
}

const mapStateToProps = (state: Tgcc.GlobalState, ownState: any) => {
    if(state && state.FilterDesignsByCategory)
        return { selected: ownState.text.toString().toUpperCase() == state.FilterDesignsByCategory.toString().toUpperCase() };
    return {selected: false};
};
export var CampusDesignCategory = connect(mapStateToProps)(Radium(_CampusDesignCategory));

